import { create } from "zustand";

const settingScreenStore = create((set) => ({
  playerScreen: {}, // Lưu trữ tất cả các player và config của họ
  gotoScreen: (playerId, screen) => 
    set((state) => ({
      playerScreen: {
        ... state.playerScreen,
        [playerId]: screen
      }
    }))
}));

export default settingScreenStore;
